import React, { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

const ProductImages = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [productImages, setProductImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchProductImage = async () => {
    try {
      const response = await api.post(`/product_image/get_data`);
      if (response.data.success) {
        setProductImage(response.data.product);
      } else {
        setError("Product not found");
      }
    } catch (err) {
      setError("Error fetching product details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductImage();
  }, []);

  const filteredItems = useMemo(() => {
    return productImages.filter(
      (item) =>
        item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.product_image_name
          ?.toLowerCase()
          .includes(filterText.toLowerCase()),
    );
  }, [productImages, filterText]);
  const deleteProductImage = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/product_image/delete/${id}`);
      if (response) {
        fetchProductImage();
        toast.success("Product Image Deleted successfully!");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const addProductImage = async (e, id) => {
    try {
      e.preventDefault();
      localStorage.setItem("product-image-list", null);
      history.push("add-edit-product");
    } catch (error) {
      console.log(error);
    }
  };

  const editProductImage = async (e, row) => {
    try {
      e.preventDefault();
      localStorage.setItem("product-image-list", JSON.stringify(row));
      history.push("add-edit-product");
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.product_image_id,
      sortable: true,
      width: "160px",
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}/${row.image}`}
          alt={row.name}
          width="80"
          height="50"
          style={{ borderRadius: "8px" }}
        />
      ),
      width: "230px",
    },
    {
      name: "Product Categories Name",
      selector: (row) => row.name,
      sortable: true,
      width: "260px",
    },
    {
      name: "Name",
      selector: (row) => row.product_image_name,
      sortable: true,
      width: "300px",
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button onClick={(e) => editProductImage(e, row)}>
            <i className="icon-edit-3"></i>
          </button>
          <button onClick={(e) => deleteProductImage(e, row.product_image_id)}>
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Product List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Product List</div>
              </li>
            </ul>
          </div>
          {/* <!-- product-list --> */}
          <div className="wg-box">
            <div className="flex justify-end">
              <Link
                className="tf-button style-1 w208"
                onClick={(e) => addProductImage(e)}
                style={{
                  textDecoration: "none",
                }}
              >
                <i className="icon-plus"></i>Add new
              </Link>
            </div>
            {error && <p className="text-danger">{error}</p>}

            {/* Search Input */}
            <div className="datatable-container col-md-10">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search product..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredItems}
                keyField="product_image_id"
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
                paginationResetDefaultPage={!!filterText}
              />

              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductImages;
